var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{attrs:{"width":"md"}},[_c('card-calculator',{attrs:{"pre-selected-card-id":_vm.slice.primary.default_card.id,"title":_vm.$prismic.asText(_vm.slice.primary.h2),"description":_vm.slice.primary.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }